var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"s-canvas",on:{"click":function($event){return _vm.updateCode()}}},[_c('canvas',{ref:"canvas",staticStyle:{"width":"112px","height":"38px"},attrs:{"canvas-id":"sCanvas","width":"112","height":"38"},on:{"error":_vm.canvasIdErrorCallback}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e946031","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/fair/commons/check.vue
// module id = null
// module chunks = 